import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { DragContainer } from '../../../../components/UI/DragContainer/DragContainer';
import { DropArea } from '../../../../components/UI/DropArea/DropArea';
import { Col, Row } from 'reactstrap';
import { renderElement } from '../../../../helpers/renderElement';
import { connect } from 'react-redux';
import { templateActions } from '../../../../../store/actions/cms/template/template.action';
import { sourceTypes } from '../../../../../constants/cms/sourceType';
import { ElementOverlay } from '../../../../components/element/Overlay/ElementOverlay';


class TemplateHeader extends React.Component {
    state = {
        isDropZoneDisabled: false
    }
    componentDidMount() {
        if (this.props.cms.enviroment !== sourceTypes.TEMPLATE) {
            this.disableDropZone(true);
        }
    }
    disableDropZone = (isDisabled) => {
        this.setState({ isDropZoneDisabled: isDisabled })
    }
    onSelect = (el) => {
        const { dispatch, cms } = this.props;
        if (!cms.editMode && cms.enviroment !== sourceTypes.TEMPLATE) { return; }
        dispatch(templateActions.select(el))
    }
    onDelete = (el) => {
        const { dispatch } = this.props;
        dispatch(templateActions.remove(el, 'HEADER'))
    }

    sortChildrens = () => {
        const { template } = this.props.template;
        const dataSource = template && template.content ? Array.from
            (template.content.header.content
                .sort((a, b) => {
                    let x = a.sortOrder;
                    let y = b.sortOrder;
                    return y < x ? 1 : y > x ? -1 : 0;
                })
                .filter(el => el.parentId === null)) : [];

        return dataSource;
    }
    render() {
        const { template } = this.props.template;
        const { selectedContainer, selectedElement } = this.props.template;
        const { editMode, enviroment } = this.props.cms

        if (template === undefined) return null;
        if (!editMode && enviroment !== sourceTypes.TEMPLATE) {
            return (
                <div className="responsive-header " style={{ width: template.content.header.innerWidth, marginLeft: 'auto', marginRight: 'auto' }}>{this.sortChildrens().map((el, index) => {
                    return (
                        <div className="animated fadeIn" key={index} >
                            <div className="element-container">
                                <Row
                                    style={{
                                        width: "100%",
                 /*                        display: "inline-flex", */
                                        marginLeft: '0px',
                                    }}
                                >
                                    <Col
                                        style={{
                                            width: "100%",
                               /*              display: "inline-flex", */
                                            padding: '0px'
                                        }}
                                    >
                                        <Col
                                            style={{
                                                maxWidth: "100%",
                                                padding: '0px',
                                   /*              display: 'inline-flex' */
                                            }} >
                                            {renderElement(el.type, el, this.disableDropZone)}
                                        </Col>

                                    </Col>
                                </Row>
                            </div>
                        </div>)
                })}
                </ div>)
        }
        return (
            <div className="responsive-header " style={{ width: template.content.header.innerWidth, marginLeft: 'auto', marginRight: 'auto' }}>
                <Droppable isDropDisabled={this.state.isDropZoneDisabled} droppableId="header">
                    {(provided, snapshot) => (
                        <DropArea {...provided.droppableProps} isDraggingOver={snapshot.isDraggingOver} ref={provided.innerRef} >
                            {this.sortChildrens().map((el, index) => {
                                return (
                                    <div className="animated fadeIn" key={index} >

                                        <Draggable key={index} draggableId={el.contentId} isDragDisabled={!editMode} index={index} >
                                            {(provided, snapshot) => (
                                                <DragContainer
                                                    {...provided.draggableProps}
                                                    {...this.props}
                                                    ref={provided.innerRef}
                                                    isDragging={snapshot.isDragging}
                                                >
                                                    <div className="element-container">

                                                        <Row
                                                            style={{
                                                                width: "100%",
                                                                display: "inline-flex",
                                                                marginLeft: '0px',
                                                            }}
                                                            onClick={() => this.onSelect(el)}
                                                        >
                                                            <Col
                                                                style={{
                                                                    width: "100%",
                                                                    display: "inline-flex",
                                                                    padding: '0px',
                                                                    border:
                                                                        (selectedElement &&
                                                                            el.contentId ===
                                                                            selectedElement.contentId) ||
                                                                            (selectedContainer &&
                                                                                el.contentId ===
                                                                                selectedContainer
                                                                                    .contentId)
                                                                            /* enviroment === sourceTypes.TEMPLATE && editMode && selectedElement &&
                                                                                el.contentId === selectedElement.contentId || selectedContainer && el.contentId === selectedContainer.contentId */

                                                                            ? "1px solid #5593dc94"
                                                                            : "none",
                                                                }}
                                                            >
                                                                <Col
                                                                    style={{
                                                                        maxWidth: "100%",
                                                                        padding: '0px',
                                                                        display: 'inline-flex'
                                                                    }} >
                                                                    {renderElement(el.type, el, this.disableDropZone)}
                                                                </Col>
                                                                {enviroment === sourceTypes.TEMPLATE ? (
                                                                    <ElementOverlay
                                                                        selectedContainer={
                                                                            selectedContainer
                                                                        }
                                                                        targetElement={el}
                                                                        dragHandleProps={
                                                                            provided.dragHandleProps
                                                                        }
                                                                        selectedElement={selectedElement}
                                                                        onDelete={this.onDelete}
                                                                    />
                                                                    /*  <div className="element-overlay">
                                                                         <div classname="element-btn-toolbar" style={{
                                                                             display: editMode && selectedElement && enviroment === sourceTypes.TEMPLATE &&
                                                                                 el.contentId === selectedElement.contentId || selectedContainer && el.contentId === selectedContainer.contentId && enviroment === sourceTypes.TEMPLATE ?
                                                                                 'inline-flex' : 'none', flexDirection: 'column', marginLeft: '-30px'
                                                                         }}>
                                                                             <span className="element-floating-btn settings">
                                                                                 <i className="fa fa-cog" style={{ fontSize: '1em' }} />
                                                                             </span>
                                                                             <span className="element-floating-btn delete">
                                                                                 <i className="fa fa-trash" onClick={() => this.onDelete(el)} style={{ fontSize: '1em' }} />
                                                                             </span>
 
                                                                         </div>
                                                                     </div> */
                                                                ) : null}
                                                            </Col>
                                                            <div {...provided.dragHandleProps} style={{ display: 'none' }}></div>
                                                        </Row>
                                                    </div>
                                                </DragContainer>)}
                                        </Draggable>
                                    </div>

                                );
                            })}
                            {template && template.content.header && template.content.header.content &&
                                template.content.header.content !== undefined &&
                                template.content.header.content.length < 1 || template && template.content.header.content !== undefined &&
                                template.content.header.content === 0 ?
                                <div className={enviroment === sourceTypes.TEMPLATE && editMode ? 'drop-area' : undefined} style={{ height: template.content.header.height }}>
                                    {provided.placeholder}
                                </div> :
                                <div >{provided.placeholder}</div>}


                        </DropArea>
                    )}
                </Droppable>
                {/*                <MenuLayout headerHeight={this.props.headerHeight} /> */}
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        alert: state.alert,
        template: state.template,
        cms: state.cms,
        form: state.form
    };
}
export default connect(mapStateToProps)(TemplateHeader);
